// Store de apps pinneadas (max 2). El resto rota en carrusel.
// useSyncExternalStore cachea referencialmente para evitar re-render infinito.

const KEY = 'wiphub_pinned'
const MAX_PINNED = 2

type Listener = () => void
const listeners = new Set<Listener>()

let cached: string[] | null = null

function readFromStorage(): string[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((s): s is string => typeof s === 'string').slice(0, MAX_PINNED)
  } catch {
    return []
  }
}

export function subscribePinned(cb: Listener): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function getPinned(): string[] {
  if (cached === null) cached = readFromStorage()
  return cached
}

function notify() {
  cached = null
  listeners.forEach((l) => l())
}

// Toggle: si está pinneada la quita; si no, la agrega (respetando MAX_PINNED).
// Si ya hay 2 pinneadas y agregan una 3ra, FIFO: descarta la primera.
export function togglePin(slug: string): void {
  const current = getPinned()
  let next: string[]
  if (current.includes(slug)) {
    next = current.filter((s) => s !== slug)
  } else {
    next = [...current, slug].slice(-MAX_PINNED)
  }
  try {
    localStorage.setItem(KEY, JSON.stringify(next))
  } catch {
    // ignore
  }
  notify()
}

export const MAX_PINS = MAX_PINNED
